import CosmoPrepLogo from '@/assets/branding/cosmoprep/cosmoprep-logo.png';

export default {
  name: 'CosmoPrep',
  isSAML: true,
  allowPersonalCourses: false,
  logo: CosmoPrepLogo,
  colors: {
    // Brand colors
    brand_primary: '#0779FF', // '#e4e7ed', // '#FF5733',
    brand_primary_hover: '#175CD3',
    brand_primary_highlight: '#84CAFF',
    brand_primary_mid: '#1C86FF',
    brand_primary_dark: '#043E80',
    brand_secondary: '#2F6CCE',
  },
};
